import type { FetchStatus } from '@tanstack/react-query'

const SIDE_MENU_DOT_REFETCH_INTERVAL_MS = 30 * 1000

/**
 * サイドメニューのドット (AC-SC-035 / 041 / 043) 用の取得方針。 再取得間隔 (30 秒) は承認案件一覧の
 * 取得間隔に揃える。 `throwOnError: false` 必須: 補助情報の失敗で全画面をエラーにしない
 * (本番 QueryClient の既定は throwOnError: true)。
 */
export const SIDE_MENU_DOT_QUERY_OPTIONS = {
  refetchInterval: SIDE_MENU_DOT_REFETCH_INTERVAL_MS,
  refetchOnWindowFocus: true,
  retry: false,
  staleTime: 0,
  throwOnError: false,
} as const

/**
 * ドットの元になる data を、 使ってよい時だけ返す。 react-query は再取得の失敗でも直前の data を
 * 残すので、 取得に失敗している間 (isError) は捨てる。 オフラインで取得が保留 (paused) の間も
 * 直前の data が残るので同様に捨てる。 取得中 (data なし) も使えない。 誤検知より未検知を選ぶ
 * (AC-SC-035 ※)。
 */
export const freshSideMenuDotData = <T>(query: {
  data: T | undefined
  isError: boolean
  fetchStatus: FetchStatus
}): T | undefined =>
  query.isError || query.fetchStatus === 'paused' ? undefined : query.data
